import React from 'react'
import { MdOutlineEmail } from 'react-icons/md'
import { MdPhone } from 'react-icons/md'
import { BsLinkedin } from "react-icons/bs";
import "./styles.css"
const Contact = () => {
  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>harsh.aayush.r1@gmail.com</h5>
            <a href="mailto:harsh.aayush.r1@gmail.com" target="_blank" rel="noreferrer">Send</a>
          </article>
        </div>
        <div className="contact__options">
          <article className="contact__option">
            <MdPhone className='contact__option-icon'/>
            <h4>LinkedIn</h4>
            <h5>https://www.linkedin.com/in/harsh2338/</h5>
            <a href="https://www.linkedin.com/in/harsh2338/" target="_blank" rel="noreferrer">Connect</a>
          </article>
        </div>
        <div className="contact__options">
          <article className="contact__option">
            <MdPhone className='contact__option-icon'/>
            <h4>Phone</h4>
            <h5>+91-9741691395</h5>
            <a href="tel:+91-9741691395" target="_blank" rel="noreferrer">Call</a>
          </article>
        </div>
        {/* <form action="">
          <input type="text" name='name' placeholder='Your Name' required />
          <input type="email" name='email' placeholder='Your Email' required />
          <textarea type="message" rows='7' placeholder='Your Message' required ></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
          
        </form> */}
      </div>
    </section>
  )
}

export default Contact